function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M40 26V21.314C40 19.678 40 18.862 39.696 18.126C39.392 17.392 38.814 16.812 37.656 15.656L28.184 6.184C27.186 5.186 26.688 4.688 26.068 4.392C25.9397 4.33036 25.8082 4.27562 25.674 4.228C25.028 4 24.322 4 22.912 4C16.422 4 13.176 4 10.978 5.772C10.5342 6.12988 10.1299 6.53417 9.772 6.978C8 9.18 8 12.422 8 18.912V26M26 5V6C26 11.656 26 14.486 27.758 16.242C29.514 18 32.344 18 38 18H39M39.5 32H34.5C33.9696 32 33.4609 32.2107 33.0858 32.5858C32.7107 32.9609 32.5 33.4696 32.5 34V38M32.5 38V44M32.5 38H38.5M8.5 44V39M8.5 39V32H12C12.9283 32 13.8185 32.3688 14.4749 33.0251C15.1313 33.6815 15.5 34.5717 15.5 35.5C15.5 36.4283 15.1313 37.3185 14.4749 37.9749C13.8185 38.6312 12.9283 39 12 39H8.5ZM20.5 32H23.5C24.5609 32 25.5783 32.4214 26.3284 33.1716C27.0786 33.9217 27.5 34.9391 27.5 36V40C27.5 41.0609 27.0786 42.0783 26.3284 42.8284C25.5783 43.5786 24.5609 44 23.5 44H20.5V32Z",
  stroke: "#FF6600",
  strokeWidth: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

function SvgPdf(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdf);
export default __webpack_public_path__ + "static/media/pdf.99bc06f3.svg";
export { ForwardRef as ReactComponent };